import React, { PureComponent } from 'react'
import { loadSwagger } from '../../services/swagger-ui'
import { getApi } from '../../services/api-catalog'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import { isAuthenticated } from '../../services/self'
//import { getCatalog, fetchSubscriptions } from '../../services/api-catalog'
import { logout } from '../../services/self'

export default class ApiDetailsPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}

    getApi(props.match.params.apiId)
    .then(api => {
      this.setState({
        api
      })
      loadSwagger(api.swagger)
    })
  }



logout() {
  logout()
  this.setState({ loggedOut: true })
}

  render() {
    return (<div>
      <div>
        <div className="Logo">
          <a className="Img-Link" href="#"><Link className="home-link" to='/'><img src={logo} className="App-logo" alt="logo" /></Link></a>
          <a className="Developer-link" href="#"><Link className="home-link" to='/'>Developer</Link></a>
        </div>

        <div className="Navbar-Div">
          <nav className="App-navbar">


            <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
            <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
            <Link className="Centered-link" to='/documentation'>Docs</Link>
            <Link className="Centered-link" to='/tools'>Tools</Link>
            <Link className="Centered-link" to='/community'>Community</Link>

            {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
            <div className="right">
              {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
              {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
            </div>

            {isAuthenticated() ? '' : (
            <span className="right">
            <SignIn className="right" />
            <Register className="right-link" />
            </span>
            )}


          </nav>
        </div>
      </div>
      <div className="App-banner">

    <span className="orange-bold"> NEWFORMA </span> Your partner for all things AECO project information management. <a className="newforma-world-link" href="https://www.newforma.com/">Learn More</a>

      </div>

      <div> <span className="spanSpace"><p className="paraSpace"></p></span></div>
<div className="content">
      <section className="swagger-section" style={{overflow: 'auto'}}>
        <div className="swagger-ui-wrap" id="swagger-ui-container"></div>
      </section>
    </div>
    </div>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/ApiDetails/index.js
 **/